import React, { useState, useEffect } from 'react';

const DiscoverSection = () => {
    const [data, setData] = useState({
        heading: "Transforming Businesses Beyond Boundaries",
        subheading: "AI",
        description: "We empower you to thrive in the digital era, making every collaboration with us a strategic investment in your success story. Our comprehensive approach combines cutting-edge technology with deep industry expertise to deliver solutions that drive real business transformation.",
        additionalText: "At MobiCloud, we understand that digital transformation is not just about technology—it's about people, processes, and culture. Our team of experts works closely with your organization to understand your unique challenges and opportunities, ensuring that every solution we deliver aligns with your business objectives and drives measurable results.",
        features: [
            {
                icon: "fas fa-check-circle text-success",
                text: "Cutting-edge AI and Machine Learning solutions"
            },
            {
                icon: "fas fa-check-circle text-success",
                text: "Scalable cloud infrastructure and services"
            },
            {
                icon: "fas fa-check-circle text-success",
                text: "Custom mobile applications for all platforms"
            },
            {
                icon: "fas fa-check-circle text-success",
                text: "End-to-end digital transformation consulting"
            },
            {
                icon: "fas fa-check-circle text-success",
                text: "24/7 technical support and maintenance"
            },
            {
                icon: "fas fa-check-circle text-success",
                text: "Enterprise-grade security and compliance"
            },
            {
                icon: "fas fa-check-circle text-success",
                text: "Strategic technology roadmap planning"
            },
            {
                icon: "fas fa-check-circle text-success",
                text: "Change management and training programs"
            }
        ]
    });

    return (
        <section id="about" className="section discover-area bg-white overflow-hidden ptb_100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-10">
                        <div className="discover-text text-center mb-5">
                            <h2 className="text-capitalize mb-4">{data.heading}</h2>
                            <h4 className="text-primary mb-3">{data.subheading}</h4>
                            <p className="text-muted fs-5 mb-4">{data.description}</p>
                            <p className="text-muted fs-6 mb-5">{data.additionalText}</p>
                        </div>
                        
                        {/* Feature List */}
                        <div className="row">
                            <div className="col-12">
                                <div className="row">
                                    {data.features.map((feature, idx) => (
                                        <div key={idx} className="col-12 col-md-6 mb-3">
                                            <div className="d-flex align-items-center">
                                                <i className={`${feature.icon} me-3 fa-lg`}></i>
                                                <span className="text-muted">{feature.text}</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        
                        <div className="text-center mt-5">
                            <a href="#contact" className="btn btn-primary btn-lg">Learn More</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DiscoverSection; 